import { useBranding } from "@/lib/branding";

// The Sheafworks mark: three stacked sheets forming an S (sources in
// docs/brand/), or the logo an admin uploaded (ADR 0048). Decorative:
// callers render the product name as text next to it, so it is hidden
// from assistive technology.
export function Logo({ className }: { className?: string }) {
  const { logo_url } = useBranding();
  if (logo_url) {
    return (
      <img
        src={logo_url}
        alt=""
        className={`${className ?? ""} object-contain`}
      />
    );
  }
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      aria-hidden
      focusable="false"
    >
      <path
        className="fill-[#1F3A5F] dark:fill-[#E9EEF4]"
        d="M16 6H44L52 14V16H24V24H12V10A4 4 0 0 1 16 6Z"
      />
      <path className="fill-[#6F8BB0] dark:fill-[#9FB3CC]" d="M44 6V14H52Z" />
      <path
        className="fill-[#2E6B4F] dark:fill-[#4FA27A]"
        d="M12 27H52V45H40V37H12Z"
      />
      <path
        className="fill-[#D9A441] dark:fill-[#E3B25A]"
        d="M12 48H52V54A4 4 0 0 1 48 58H20L12 50Z"
      />
      <path className="fill-[#A9792A] dark:fill-[#B8862E]" d="M12 50H20V58Z" />
    </svg>
  );
}
